// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiFacility {
    static getAttributeTypeMap() {
        return MedicalBiFacility.attributeTypeMap;
    }
}
MedicalBiFacility.discriminator = undefined;
MedicalBiFacility.additionalProperties = false;
MedicalBiFacility.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiFacility.js.map